import { EventEmitter } from 'events';

import { isSSR } from '@/utils/helper';

import { AllEvents, Callback, EventList, Payload } from './types';

export type Plugin = () => void;

class Events<T extends EventList> {
    private _emitter = new EventEmitter();

    emit<K extends keyof T>(eventName: K, ...payload: Payload<T, K>) {
        if (isSSR) {
            return false;
        }

        return this._emitter.emit(eventName as string, ...payload);
    }

    on<K extends keyof T>(eventName: K, cb: Callback<T, K>) {
        if (isSSR) {
            return this;
        }

        this._emitter.on(eventName as string, cb as (...params: any[]) => void);

        return this;
    }

    removeListener<K extends keyof T>(eventName: K, cb: Callback<T, K>) {
        if (isSSR) {
            return this;
        }

        this._emitter.removeListener(
            eventName as string,
            cb as (...params: any[]) => void
        );

        return this;
    }
}

export const events = new Events<AllEvents>();
